<template>
  <aside class="listing-product-carousel">
    <!-- Title -->
    <div class="row-1">
      <template v-if="fromDato">
        <div
          v-html="props.label"
          class="is-text-uppercase is-text-center"
          :class="props.bigTitle ? 'title-xl-1' : 'text-l-1'"
        />
      </template>
      <template v-else>
        <h3 class="text-l-1 is-text-center is-text-uppercase">
          {{ props.label }}
        </h3>
      </template>
      <!--<template v-if="bigTitle">
        <h3 class="title-xl-1 is-text-center is-text-uppercase">
        {{ props.label }}
      </h3>
      </template>
      <template v-else>
      <h3 class="text-l-1 is-text-center is-text-uppercase">
        {{ props.label }}
      </h3>
      </template>-->
    </div>
    <div class="listing-product-carousel__swiper m-top-l-1">
      <WidgetSliderSwiper :length="props.slides?.length">
        <template
          v-for="(slide, index) in props.slides"
          :key="index"
          #[`slide-${index}`]
        >
          <ListingProjectBlock :item="slide" />
        </template>
      </WidgetSliderSwiper>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ListingProjectBlock',
}
</script>

<script setup>
const props = defineProps({
  slides: Array,
  label: String,
  bigTitle: {
    type: Boolean,
    default: false,
  },
  fromDato: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
